import React from 'react'
import Sidebar from '@/components/ui/Sidebar/Sidebar'
import type { Site } from '@/types/api'
import { FiLayers } from 'react-icons/fi'

interface SelectSiteSidebarProps {
  isOpen: boolean
  onClose: () => void
  sites: Site[]
  loading?: boolean
  error?: string | null
  onSelectSite?: (site: Site) => void | Promise<void>
}

const SelectSiteSidebar: React.FC<SelectSiteSidebarProps> = ({ isOpen, onClose, sites, loading = false, error = null, onSelectSite }) => {
  return (
    <Sidebar isOpen={isOpen} onClose={onClose} title="Select a Site">
      <div className="space-y-3">
        {loading && (
          <div className="text-sm text-gray-500">Loading sites...</div>
        )}
        {error && (
          <div className="text-sm text-red-600">{error}</div>
        )}
        {!loading && !error && sites.length === 0 && (
          <div className="text-sm text-gray-500">No sites available</div>
        )}
        {!loading && !error && sites.length > 0 && (
          <div className="space-y-2">
            {sites.map(site => (
              <button
                key={site.objectId}
                type="button"
                onClick={() => onSelectSite?.(site)}
                className="w-full text-left p-3 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-start gap-3"
              >
                <FiLayers className="h-5 w-5 text-gray-400" />
                <div className="min-w-0">
                  <div className="font-medium truncate">{site.name || 'Unnamed Site'}</div>
                  {(site.street || site.city || site.state || site.postcode || site.country) && (
                    <div className="text-xs text-gray-500 truncate">{[site.street, site.city, site.state, site.postcode, site.country].filter(Boolean).join(', ')}</div>
                  )}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </Sidebar>
  )
}

export default SelectSiteSidebar